import axios from "axios";
import { SET_ERROR, LOCATION_LIST } from "../types"

export const GetLocationWage = () => {
    return async (dispatch) => {
        await axios.get('api/listing/get-counties').then(response => {
            dispatch({
                type: LOCATION_LIST,
                payload: response.data.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};